var render = function render(){var _vm=this,_c=_vm._self._c;return _c('validation-field',{attrs:{"name":_vm.name,"label":_vm.label},scopedSlots:_vm._u([{key:"default",fn:function({ id, modelValue, invalid, name, onChange }){return [_c('base-textarea',{attrs:{"id":id,"name":name,"invalid":invalid,"value":modelValue,"placeholder":_vm.placeholder,"maxlength":_vm.maxlength},on:{"inputValue":onChange}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }